
export { CollectionName } from "/codebuild/output/src2546908341/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"